/**
 * @generated SignedSource<<d592ec00e1bb9d55e8667521a254025a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ViewPageConversation_commentThread$data = {
  readonly author: {
    readonly __typename: string;
    readonly accountId?: string | null;
    readonly displayName: string | null;
    readonly permissionType: SitePermissionType | null;
    readonly profilePicture: {
      readonly path: string;
    } | null;
    readonly type: string | null;
  };
  readonly body: {
    readonly value: string;
  };
  readonly container: {
    readonly id: string | null;
  };
  readonly contentStatus: string;
  readonly contributors: ReadonlyArray<{
    readonly __typename: string;
    readonly accountId?: string | null;
    readonly displayName: string | null;
    readonly profilePicture: {
      readonly path: string;
    } | null;
  } | null> | null;
  readonly createdAt: {
    readonly value: string;
  };
  readonly createdAtNonLocalized: string;
  readonly id: string;
  readonly links: {
    readonly editui: string | null;
    readonly webui: string | null;
  };
  readonly location: {
    readonly __typename: string;
    readonly commentResolveProperties?: {
      readonly resolved: boolean;
      readonly resolvedFriendlyDate: string | null;
      readonly resolvedTime: AGG$Long | null;
      readonly resolvedUser: string | null;
    } | null;
    readonly inlineMarkerRef?: string | null;
    readonly inlineResolveProperties?: {
      readonly isDangling: boolean;
      readonly resolved: boolean;
      readonly resolvedFriendlyDate: string | null;
      readonly resolvedTime: AGG$Long | null;
      readonly resolvedUser: string | null;
    } | null;
    readonly inlineText?: string | null;
    readonly type: string;
  };
  readonly parentId: string | null;
  readonly permissions: {
    readonly isEditable: boolean;
    readonly isRemovable: boolean;
    readonly isResolvable: boolean;
  };
  readonly reactionsSummary?: {
    readonly ari: string;
    readonly containerAri: string;
    readonly reactionsCount: number;
    readonly reactionsSummaryForEmoji: ReadonlyArray<{
      readonly count: number;
      readonly emojiId: string;
      readonly id: string;
      readonly reacted: boolean;
    } | null>;
  } | null;
  readonly replies: ReadonlyArray<{
    readonly author: {
      readonly __typename: string;
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly permissionType: SitePermissionType | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
    };
    readonly body: {
      readonly value: string;
    };
    readonly contentStatus: string;
    readonly contributors: ReadonlyArray<{
      readonly __typename: string;
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
    } | null> | null;
    readonly createdAt: {
      readonly value: string;
    };
    readonly createdAtNonLocalized: string;
    readonly id: string;
    readonly links: {
      readonly editui: string | null;
      readonly webui: string | null;
    };
    readonly location: {
      readonly __typename: string;
      readonly commentResolveProperties?: {
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null;
        readonly resolvedTime: AGG$Long | null;
        readonly resolvedUser: string | null;
      } | null;
      readonly inlineMarkerRef?: string | null;
      readonly inlineResolveProperties?: {
        readonly isDangling: boolean;
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null;
        readonly resolvedTime: AGG$Long | null;
        readonly resolvedUser: string | null;
      } | null;
      readonly inlineText?: string | null;
      readonly type: string;
    };
    readonly parentId: string | null;
    readonly permissions: {
      readonly isEditable: boolean;
      readonly isRemovable: boolean;
      readonly isResolvable: boolean;
    };
    readonly reactionsSummary?: {
      readonly ari: string;
      readonly containerAri: string;
      readonly reactionsCount: number;
      readonly reactionsSummaryForEmoji: ReadonlyArray<{
        readonly count: number;
        readonly emojiId: string;
        readonly id: string;
        readonly reacted: boolean;
      } | null>;
    } | null;
    readonly version: {
      readonly by: {
        readonly __typename: string;
        readonly displayName: string | null;
      } | null;
      readonly number: number | null;
      readonly when: string | null;
    };
  } | null>;
  readonly version: {
    readonly by: {
      readonly __typename: string;
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly type: string | null;
    } | null;
    readonly friendlyWhen: string | null;
    readonly number: number | null;
    readonly when: string | null;
  };
  readonly " $fragmentType": "ViewPageConversation_commentThread";
};
export type ViewPageConversation_commentThread$key = {
  readonly " $data"?: ViewPageConversation_commentThread$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewPageConversation_commentThread">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v3 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v4 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v7 = {
  "kind": "LinkedField",
  "name": "contributors",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v4/*: any*/),
    (v6/*: any*/)
  ]
},
v8 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v9 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v10 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v11 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v8/*: any*/)
},
v12 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v13 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "editui"
    },
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v15 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v16 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v17 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v18 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "commentResolveProperties",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/)
          ]
        }
      ],
      "type": "FooterComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "inlineMarkerRef"
        },
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "inlineResolveProperties",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isDangling"
            },
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "inlineText"
        }
      ],
      "type": "InlineComment"
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v20 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v21 = {
  "condition": "includeCommentReactions",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "childType",
          "value": "comment"
        },
        {
          "kind": "Literal",
          "name": "contentType",
          "value": "page"
        },
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "pageId"
        }
      ],
      "concreteType": "ReactionsSummaryResponse",
      "kind": "LinkedField",
      "name": "reactionsSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        {
          "kind": "ScalarField",
          "name": "containerAri"
        },
        {
          "kind": "ScalarField",
          "name": "reactionsCount"
        },
        {
          "concreteType": "ReactionsSummaryForEmoji",
          "kind": "LinkedField",
          "name": "reactionsSummaryForEmoji",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "emojiId"
            },
            {
              "kind": "ScalarField",
              "name": "reacted"
            }
          ]
        }
      ]
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "number"
},
v23 = {
  "kind": "ScalarField",
  "name": "when"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "includeCommentReactions"
    },
    {
      "kind": "RootArgument",
      "name": "pageId"
    }
  ],
  "kind": "Fragment",
  "name": "ViewPageConversation_commentThread",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/)
      ]
    },
    (v7/*: any*/),
    (v9/*: any*/),
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "container",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    {
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "replies",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "name": "author",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v6/*: any*/),
            (v4/*: any*/)
          ]
        },
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "by",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/)
              ]
            },
            (v22/*: any*/),
            (v23/*: any*/)
          ]
        },
        (v7/*: any*/)
      ]
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "by",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v5/*: any*/),
            (v2/*: any*/),
            (v6/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "friendlyWhen"
        },
        (v22/*: any*/),
        (v23/*: any*/)
      ]
    },
    (v21/*: any*/)
  ],
  "type": "Comment"
};
})();

(node as any).hash = "60bda14127b38a990b0614c09aa009d2";

export default node;
